<template>
  <video
    autoplay="autoplay"
    loop="loop"
    muted="muted"
    playsinline="true"
    :src="src"
    :poster="poster"
    class="video"
    style="object-fit: cover; object-position: 50% 50%;" />
</template>
<script>
export default {
  props: {
    src: {
      type: String,
      default: ''
    },
    poster: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
  .video {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/BackgroundVideo.vue